var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5173  \u95ED") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coinbase",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E0B\\u62C9\\u83DC\\u5355",
    transform: "translate(-32.000000, -56.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5173--\\u95ED",
    transform: "translate(32.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9546875,16.3234375 L28.2625,6.015625 C28.7828125,5.4953125 28.7828125,4.6375 28.2625,4.1171875 L28.20625,4.0609375 C27.6859375,3.540625 26.828125,3.540625 26.3078125,4.0609375 L16,14.3828125 L5.6921875,4.0609375 C5.171875,3.540625 4.3140625,3.540625 3.79375,4.0609375 L3.7375,4.1171875 C3.203125,4.6375 3.203125,5.4953125 3.7375,6.015625 L14.0453125,16.3234375 L3.7375,26.63125 C3.2171875,27.1515625 3.2171875,28.009375 3.7375,28.5296875 L3.79375,28.5859375 C4.3140625,29.10625 5.171875,29.10625 5.6921875,28.5859375 L16,18.278125 L26.3078125,28.5859375 C26.828125,29.10625 27.6859375,29.10625 28.20625,28.5859375 L28.2625,28.5296875 C28.7828125,28.009375 28.7828125,27.1515625 28.2625,26.63125 L17.9546875,16.3234375 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#353F52"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.9d864f534db5fff99b10f7683586281b.svg";
export { ForwardRef as ReactComponent };